/**
 * 플래너 모델 계산 추적 훅
 * 
 * 플래너 모델 계산의 의도-결과를 추적
 * - planner_compute_start: 계산 시작
 * - planner_compute_success: 계산 성공
 * - planner_compute_fail: 계산 실패
 * 
 * @example
 * ```tsx
 * function PlannerResultPage() {
 *   const plannerCompute = usePlannerCompute();
 *   
 *   const handleCompute = async (portfolioId: number) => {
 *     plannerCompute.start({ portfolio_id: portfolioId });
 *     
 *     try {
 *       const result = await computePlannerAPI(portfolioId);
 *       plannerCompute.success();
 *     } catch (error) {
 *       plannerCompute.fail('backend_5xx');
 *     }
 *   };
 * }
 * ```
 */

import { useIntent } from '../useIntent';
import { track } from '../../../../core/client';

export interface PlannerComputeContext {
  portfolio_id?: number;
  answer?: any;
}

export interface PlannerComputeActions {
  start: (context?: PlannerComputeContext, options?: {
    parentIntentId?: string;
    parentIntentType?: string;
  }) => string | undefined;
  success: () => void;
  fail: (reason?: string) => void;
}

/**
 * 플래너 모델 계산 추적 훅
 */
export function usePlannerCompute(): PlannerComputeActions {
  const intent = useIntent<PlannerComputeContext>({
    type: 'planner_compute',
    requiredGate: 'none',
    onStart: ({ intent_id, context, parent_intent_id, required_gate }) => {
      track('planner_compute_start', {
        intent_id,
        parent_intent_id,
        required_gate,
        answer: context?.answer,
      });
    },
    onSuccess: ({ intent_id, context, latency_ms }) => {
      track('planner_compute_success', {
        intent_id,
        // portfolio_id: context?.portfolio_id,
        latency_ms,
      });
    },
    onFail: ({ intent_id, context, fail_reason }) => {
      track('planner_compute_fail', {
        intent_id,
        // portfolio_id: context?.portfolio_id,
        fail_reason,
      });
    },
  });

  return {
    start: (context, options) => intent.start(context, options),
    success: () => intent.success(),
    fail: (reason) => intent.fail(reason),
  };
}

